var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHeaderFlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.758 8.367h1.41v1.411h-1.41z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#00D87E",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.565 8.435h2.822v2.822h-2.822zM8.75 12.317a1.06 1.06 0 1 1-1.06-1.057h1.06V8.435H7.682a3.883 3.883 0 1 0 3.883 3.882V11.26H8.75v1.057zM12.622 7.022H15.8V4.2h-3.178A3.885 3.885 0 0 0 8.75 8.082v.353h2.815v-.353a1.063 1.063 0 0 1 1.057-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16FF99",
    d: "M8.742 11.26h2.823V8.435H8.743z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeaderFlow);
export default __webpack_public_path__ + "static/media/ic-header-flow.585b3a7ba842e33ee08b940241dfd1fe.svg";
export { ForwardRef as ReactComponent };